import { render } from "./AdminDriverCreate.vue?vue&type=template&id=b3d68e88&scoped=true&ts=true&lang=true"
import script from "./AdminDriverCreate.vue?vue&type=script&lang=ts"
export * from "./AdminDriverCreate.vue?vue&type=script&lang=ts"

import "./AdminDriverCreate.vue?vue&type=style&index=0&id=b3d68e88&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d68e88"]])

export default __exports__